import { useState, useEffect, useCallback } from "react";

import { API } from "../config";

// ===== GRUPPI COLONNE — ordine definitivo (21 gruppi) =====
const GRUPPI_COLONNE = [
  {
    nome: "Anagrafica",
    colonne: [
      { id: "stagione", label: "Stagione" },
      { id: "lega", label: "Lega" },
      { id: "data", label: "Data" },
      { id: "time_it", label: "Ora IT" },
      { id: "casa", label: "Casa" },
      { id: "trasferta", label: "Trasferta" },
      { id: "mese", label: "Mese" },
    ],
  },
  {
    nome: "Quote 1X2 ore9 + Aggio",
    colonne: [
      { id: "q_1_ore9", label: "P 1 ore9" },
      { id: "q_x_ore9", label: "P X ore9" },
      { id: "q_2_ore9", label: "P 2 ore9" },
      { id: "aggio_bf", label: "Aggio Bookmaker" },
    ],
  },
  {
    nome: "Quote INS",
    colonne: [
      { id: "q_ins_1", label: "Q INS 1" },
      { id: "q_ins_x", label: "Q INS X" },
      { id: "q_ins_2", label: "Q INS 2" },
    ],
  },
  {
    nome: "Differenza Quote (INS - ore9)",
    colonne: [
      { id: "diff_ins_1", label: "dQ 1 (INS-BF ore9)" },
      { id: "diff_ins_x", label: "dQ X (INS-BF ore9)" },
      { id: "diff_ins_2", label: "dQ 2 (INS-BF ore9)" },
    ],
  },
  {
    nome: "Forma L6",
    colonne: [
      { id: "forma_l6_home_disp", label: "Forma L6 Home Disp." },
      { id: "forma_l6_home_mpt", label: "Forma L6 Home MPT" },
      { id: "forma_l6_away_disp", label: "Forma L6 Away Disp." },
      { id: "forma_l6_away_mpt", label: "Forma L6 Away MPT" },
      { id: "colore_l6_home", label: "Colore L6 Home" },
      { id: "colore_l6_away", label: "Colore L6 Away" },
    ],
  },
  {
    nome: "Rating ELO",
    colonne: [
      { id: "rating_home", label: "ELO Home" },
      { id: "rating_away", label: "ELO Away" },
      { id: "d_rating", label: "\u0394 ELO" },
      { id: "frating_home", label: "Fascia ELO Home" },
      { id: "frating_away", label: "Fascia ELO Away" },
    ],
  },
  {
    nome: "Classifica",
    colonne: [
      { id: "fclass_home", label: "Fascia Class. Home" },
      { id: "fclass_away", label: "Fascia Class. Away" },
    ],
  },
  {
    nome: "Trend",
    colonne: [
      { id: "gc_gt_l5", label: "GC-GT L5" },
      { id: "tmp_l5_stag_home", label: "TMP L5/Stag Home" },
      { id: "tmp_l5_stag_away", label: "TMP L5/Stag Away" },
      { id: "tp_l5_sl5_home", label: "TP L5/SL5 Home" },
      { id: "tp_l5_sl5_away", label: "TP L5/SL5 Away" },
    ],
  },
  {
    nome: "Neoaggiunte",
    colonne: [
      { id: "home_neoagg", label: "Neoagg. Home" },
      { id: "away_neoagg", label: "Neoagg. Away" },
    ],
  },
  {
    nome: "Risultati",
    colonne: [
      { id: "ht_gol_home", label: "HT Gol Home" },
      { id: "ht_gol_away", label: "HT Gol Away" },
      { id: "et_gol_home", label: "FT Gol Home" },
      { id: "et_gol_away", label: "FT Gol Away" },
    ],
  },
  {
    nome: "P/L 1X2 ore9",
    colonne: [
      { id: "pl_p1_ore9", label: "PL P1 ore9" },
      { id: "pl_px_ore9", label: "PL PX ore9" },
      { id: "pl_p2_ore9", label: "PL P2 ore9" },
      { id: "pl_b1_ore9", label: "PL B1 ore9" },
      { id: "pl_bx_ore9", label: "PL BX ore9" },
      { id: "pl_b2_ore9", label: "PL B2 ore9" },
    ],
  },
  {
    nome: "Quote 1X2 5mKO",
    colonne: [
      { id: "qp_1", label: "P 1 5mKO" },
      { id: "qp_x", label: "P X 5mKO" },
      { id: "qp_2", label: "P 2 5mKO" },
      { id: "qb_1", label: "B 1 5mKO" },
      { id: "qb_x", label: "B X 5mKO" },
      { id: "qb_2", label: "B 2 5mKO" },
    ],
  },
  {
    nome: "Differenza Quote (5mKO - ore9)",
    colonne: [
      { id: "d_q_1", label: "dQ 1 (5mKO-ore9)" },
      { id: "d_q_x", label: "dQ X (5mKO-ore9)" },
      { id: "d_q_2", label: "dQ 2 (5mKO-ore9)" },
    ],
  },
  {
    nome: "P/L 1X2 5mKO",
    colonne: [
      { id: "pl_qp_1", label: "PL P1 5mKO" },
      { id: "pl_qp_x", label: "PL PX 5mKO" },
      { id: "pl_qp_2", label: "PL P2 5mKO" },
      { id: "pl_qb_1", label: "PL B1 5mKO" },
      { id: "pl_qb_x", label: "PL BX 5mKO" },
      { id: "pl_qb_2", label: "PL B2 5mKO" },
    ],
  },
  {
    nome: "Quote 1X2 ore8",
    colonne: [
      { id: "q_1_ore8", label: "P 1 ore8" },
      { id: "q_x_ore8", label: "P X ore8" },
      { id: "q_2_ore8", label: "P 2 ore8" },
      { id: "qb_1_ore8", label: "B 1 ore8" },
      { id: "qb_x_ore8", label: "B X ore8" },
      { id: "qb_2_ore8", label: "B 2 ore8" },
    ],
  },
  {
    nome: "P/L 1X2 ore8",
    colonne: [
      { id: "pl_p1_ore8", label: "PL P1 ore8" },
      { id: "pl_px_ore8", label: "PL PX ore8" },
      { id: "pl_p2_ore8", label: "PL P2 ore8" },
      { id: "pl_b1_ore8", label: "PL B1 ore8" },
      { id: "pl_bx_ore8", label: "PL BX ore8" },
      { id: "pl_b2_ore8", label: "PL B2 ore8" },
    ],
  },
  {
    nome: "Quote O/U ore8",
    colonne: [
      { id: "qp_u15_ore8", label: "P U1.5 ore8" },
      { id: "qp_o15_ore8", label: "P O1.5 ore8" },
      { id: "qb_u15_ore8", label: "B U1.5 ore8" },
      { id: "qb_o15_ore8", label: "B O1.5 ore8" },
      { id: "qp_u25_ore8", label: "P U2.5 ore8" },
      { id: "qp_o25_ore8", label: "P O2.5 ore8" },
      { id: "qb_u25_ore8", label: "B U2.5 ore8" },
      { id: "qb_o25_ore8", label: "B O2.5 ore8" },
      { id: "qp_u35_ore8", label: "P U3.5 ore8" },
      { id: "qp_o35_ore8", label: "P O3.5 ore8" },
      { id: "qb_u35_ore8", label: "B U3.5 ore8" },
      { id: "qb_o35_ore8", label: "B O3.5 ore8" },
    ],
  },
  {
    nome: "P/L O/U ore8",
    colonne: [
      { id: "pl_p_u15_ore8", label: "PL P U1.5 ore8" },
      { id: "pl_p_o15_ore8", label: "PL P O1.5 ore8" },
      { id: "pl_b_u15_ore8", label: "PL B U1.5 ore8" },
      { id: "pl_b_o15_ore8", label: "PL B O1.5 ore8" },
      { id: "pl_p_u25_ore8", label: "PL P U2.5 ore8" },
      { id: "pl_p_o25_ore8", label: "PL P O2.5 ore8" },
      { id: "pl_b_u25_ore8", label: "PL B U2.5 ore8" },
      { id: "pl_b_o25_ore8", label: "PL B O2.5 ore8" },
      { id: "pl_p_u35_ore8", label: "PL P U3.5 ore8" },
      { id: "pl_p_o35_ore8", label: "PL P O3.5 ore8" },
      { id: "pl_b_u35_ore8", label: "PL B U3.5 ore8" },
      { id: "pl_b_o35_ore8", label: "PL B O3.5 ore8" },
    ],
  },
  {
    nome: "Quote O/U 5mKO",
    colonne: [
      { id: "qp_u15", label: "P U1.5 5mKO" },
      { id: "qp_o15", label: "P O1.5 5mKO" },
      { id: "qb_u15", label: "B U1.5 5mKO" },
      { id: "qb_o15", label: "B O1.5 5mKO" },
      { id: "qp_u25", label: "P U2.5 5mKO" },
      { id: "qp_o25", label: "P O2.5 5mKO" },
      { id: "qb_u25", label: "B U2.5 5mKO" },
      { id: "qb_o25", label: "B O2.5 5mKO" },
      { id: "qp_u35", label: "P U3.5 5mKO" },
      { id: "qp_o35", label: "P O3.5 5mKO" },
      { id: "qb_u35", label: "B U3.5 5mKO" },
      { id: "qb_o35", label: "B O3.5 5mKO" },
    ],
  },
  {
    nome: "P/L O/U 5mKO",
    colonne: [
      { id: "pl_qp_u15", label: "PL P U1.5 5mKO" },
      { id: "pl_qp_o15", label: "PL P O1.5 5mKO" },
      { id: "pl_qb_u15", label: "PL B U1.5 5mKO" },
      { id: "pl_qb_o15", label: "PL B O1.5 5mKO" },
      { id: "pl_qp_u25", label: "PL P U2.5 5mKO" },
      { id: "pl_qp_o25", label: "PL P O2.5 5mKO" },
      { id: "pl_qb_u25", label: "PL B U2.5 5mKO" },
      { id: "pl_qb_o25", label: "PL B O2.5 5mKO" },
      { id: "pl_qp_u35", label: "PL P U3.5 5mKO" },
      { id: "pl_qp_o35", label: "PL P O3.5 5mKO" },
      { id: "pl_qb_u35", label: "PL B U3.5 5mKO" },
      { id: "pl_qb_o35", label: "PL B O3.5 5mKO" },
    ],
  },
  {
    nome: "Quote BTTS ore8",
    colonne: [
      { id: "qp_btts_si", label: "P BTTS S\u00ec" },
      { id: "qp_btts_no", label: "P BTTS No" },
      { id: "qb_btts_si", label: "B BTTS S\u00ec" },
      { id: "qb_btts_no", label: "B BTTS No" },
    ],
  },
  {
    nome: "P/L BTTS ore8",
    colonne: [
      { id: "pl_p_btts_si", label: "PL P BTTS S\u00ec" },
      { id: "pl_p_btts_no", label: "PL P BTTS No" },
      { id: "pl_b_btts_si", label: "PL B BTTS S\u00ec" },
      { id: "pl_b_btts_no", label: "PL B BTTS No" },
    ],
  },
];

// Default preselezionati
const DEFAULT_COLONNE = new Set([
  "stagione", "lega", "data", "time_it", "casa", "trasferta",
  "q_1_ore9", "q_x_ore9", "q_2_ore9", "aggio_bf",
  "q_ins_1", "q_ins_x", "q_ins_2", "diff_ins_1", "diff_ins_x", "diff_ins_2",
  "forma_l6_home_disp", "forma_l6_home_mpt", "forma_l6_away_disp", "forma_l6_away_mpt",
  "colore_l6_home", "colore_l6_away",
  "rating_home", "rating_away", "d_rating", "frating_home", "frating_away",
  "fclass_home", "fclass_away",
  "ht_gol_home", "ht_gol_away", "et_gol_home", "et_gol_away",
  "pl_p1_ore9", "pl_px_ore9", "pl_p2_ore9", "pl_b1_ore9", "pl_bx_ore9", "pl_b2_ore9",
  "qp_1", "qp_x", "qp_2", "qb_1", "qb_x", "qb_2",
  "d_q_1", "d_q_x", "d_q_2",
]);

const TUTTE_COLONNE = GRUPPI_COLONNE.flatMap(g => g.colonne.map(c => c.id));

// ===== STILI =====
const S = {
  page: { padding: "24px 28px", fontFamily: "'DM Sans', sans-serif" },
  title: { fontSize: 22, fontWeight: 700, color: "#1E293B", marginBottom: 4, letterSpacing: "-0.02em" },
  subtitle: { fontSize: 13, color: "#64748B", marginBottom: 20 },
  layout: { display: "flex", gap: 20, alignItems: "flex-start" },
  colSx: { width: "38%", minWidth: 320, flexShrink: 0 },
  colDx: { flex: 1, minWidth: 0 },
  card: {
    background: "#fff", borderRadius: 10, border: "1px solid #E2E8F0",
    padding: "18px 20px", marginBottom: 16,
  },
  cardTitle: { fontSize: 13, fontWeight: 700, color: "#1E293B", marginBottom: 12 },
  label: { fontSize: 11, fontWeight: 600, color: "#475569", marginBottom: 3, display: "block" },
  select: {
    width: "100%", padding: "6px 8px", fontSize: 12, border: "1px solid #CBD5E1",
    borderRadius: 6, fontFamily: "'DM Sans', sans-serif", color: "#1E293B",
    background: "#fff", outline: "none", boxSizing: "border-box",
  },
  input: {
    width: "100%", padding: "6px 8px", fontSize: 12, border: "1px solid #CBD5E1",
    borderRadius: 6, fontFamily: "'DM Sans', sans-serif", color: "#1E293B",
    background: "#fff", outline: "none", boxSizing: "border-box",
  },
  filterChip: {
    display: "inline-flex", alignItems: "center", gap: 4,
    padding: "2px 9px", borderRadius: 12, fontSize: 11, fontWeight: 600,
    background: "#EFF6FF", color: "#2563EB", border: "1px solid #BFDBFE",
    margin: "2px 3px 2px 0",
  },
  filterChipX: { fontSize: 13, fontWeight: 700, color: "#93C5FD", marginLeft: 2, cursor: "pointer" },
  colBadge: {
    display: "inline-flex", alignItems: "center", gap: 3,
    padding: "2px 8px", borderRadius: 10, fontSize: 10, fontWeight: 600,
    background: "#F0FDF4", color: "#15803D", border: "1px solid #BBF7D0",
    margin: "1px 2px",
  },
  colBadgeX: { fontSize: 12, fontWeight: 700, color: "#86EFAC", marginLeft: 1, cursor: "pointer" },
  colGroupLabel: {
    fontSize: 10, fontWeight: 700, color: "#94A3B8", textTransform: "uppercase",
    letterSpacing: "0.04em", margin: "3px 4px 1px 0", display: "inline-block",
  },
  btn: {
    padding: "8px 16px", fontSize: 12, fontWeight: 700, border: "none",
    borderRadius: 7, cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
    transition: "background 0.15s, opacity 0.15s",
  },
  btnPrimary: { background: "#2563EB", color: "#fff" },
  btnSecondary: { background: "#F1F5F9", color: "#475569", border: "1px solid #E2E8F0" },
  btnSuccess: { background: "#08976D", color: "#fff" },
  btnSmall: { padding: "4px 10px", fontSize: 10 },
  groupHeader: {
    display: "flex", alignItems: "center", gap: 7, padding: "5px 0",
    cursor: "pointer", userSelect: "none",
  },
  groupName: { fontSize: 12, fontWeight: 700, color: "#1E293B" },
  groupCount: { fontSize: 10, color: "#94A3B8", fontWeight: 500 },
  colItem: {
    display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 0",
    fontSize: 11, color: "#475569", cursor: "pointer", minWidth: 170,
  },
  conteggio: {
    display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
    padding: "10px 12px", background: "#F8FAFC", borderRadius: 8,
    border: "1px solid #E2E8F0", fontSize: 13, fontWeight: 600, color: "#1E293B",
    marginBottom: 12,
  },
  conteggioNum: { fontSize: 18, fontWeight: 800, color: "#2563EB" },
};

export default function EsportaDatabase() {
  const [campionati, setCampionati] = useState([]);
  const [stagioni, setStagioni] = useState([]);
  const [selStagioni, setSelStagioni] = useState([]);
  const [selLeghe, setSelLeghe] = useState([]);
  const [dataDa, setDataDa] = useState("");
  const [dataA, setDataA] = useState("");
  const [tipoRisultato, setTipoRisultato] = useState("tutte");
  const [selColonne, setSelColonne] = useState(new Set(DEFAULT_COLONNE));
  const [gruppiAperti, setGruppiAperti] = useState({});
  const [conteggio, setConteggio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [popup, setPopup] = useState(null); // { num, volumeElevato }

  useEffect(() => {
    fetch(`${API}/campionati`).then(r => r.json()).then(d => {
      setCampionati(d.map(c => c.nome_bf).sort());
    }).catch(() => {});
    fetch(`${API}/stagioni`).then(r => r.json()).then(d => {
      setStagioni(d.sort());
    }).catch(() => {});
  }, []);

  const buildPayload = useCallback(() => ({
    stagioni: selStagioni,
    leghe: selLeghe,
    data_da: dataDa || null,
    data_a: dataA || null,
    tipo_risultato: tipoRisultato,
    colonne: TUTTE_COLONNE.filter(id => selColonne.has(id)),
  }), [selStagioni, selLeghe, dataDa, dataA, tipoRisultato, selColonne]);

  const contaPartite = useCallback(async () => {
    setLoading(true);
    setConteggio(null);
    try {
      const r = await fetch(`${API}/export/conta`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(buildPayload()),
      });
      const d = await r.json();
      setConteggio(d.conteggio ?? 0);
    } catch { setConteggio(-1); }
    setLoading(false);
  }, [buildPayload]);

  const esportaExcel = async () => {
    if (selColonne.size === 0) { alert("Seleziona almeno una colonna."); return; }
    setLoading(true);
    let num = null;
    try {
      const rc = await fetch(`${API}/export/conta`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(buildPayload()),
      });
      const dc = await rc.json();
      num = dc.conteggio ?? 0;
      setConteggio(num);
    } catch {}
    setLoading(false);
    setPopup({ num, volumeElevato: num !== null && num > 5000 });
  };

  const confermaExport = async () => {
    setPopup(null);
    setExporting(true);
    try {
      const r = await fetch(`${API}/export/excel`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(buildPayload()),
      });
      if (!r.ok) {
        const err = await r.json();
        alert(err.detail || err.errore || "Errore export");
        setExporting(false);
        return;
      }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "investisport_export.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) { alert("Errore: " + e.message); }
    setExporting(false);
  };

  const toggleInArray = (arr, setArr, val) => {
    if (arr.includes(val)) setArr(arr.filter(v => v !== val));
    else setArr([...arr, val]);
  };
  const toggleColonna = (id) => {
    setSelColonne(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };
  const toggleGruppo = (nomeGruppo) => {
    const cols = GRUPPI_COLONNE.find(g => g.nome === nomeGruppo)?.colonne || [];
    const ids = cols.map(c => c.id);
    const tuttiSel = ids.every(id => selColonne.has(id));
    setSelColonne(prev => {
      const next = new Set(prev);
      ids.forEach(id => tuttiSel ? next.delete(id) : next.add(id));
      return next;
    });
  };
  const selezionaTutte = () => setSelColonne(new Set(TUTTE_COLONNE));
  const deselezionaTutte = () => setSelColonne(new Set());
  const ripristinaDefault = () => setSelColonne(new Set(DEFAULT_COLONNE));

  const renderMultiSelect = (label, opzioni, sel, setSel) => (
    <div style={{ marginBottom: 12 }}>
      <label style={S.label}>{label}</label>
      <select style={S.select} value=""
        onChange={e => { if (e.target.value) toggleInArray(sel, setSel, e.target.value); }}>
        <option value="">{"\u2014"} Seleziona {"\u2014"}</option>
        {opzioni.filter(o => !sel.includes(o)).map(o => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
      {sel.length > 0 && (
        <div style={{ marginTop: 4 }}>
          {sel.map(v => (
            <span key={v} style={S.filterChip}>
              {v}
              <span style={S.filterChipX} onClick={() => toggleInArray(sel, setSel, v)}>{"\u00d7"}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );

  const renderBadgeColonne = () => {
    const gruppiConSel = GRUPPI_COLONNE.filter(g =>
      g.colonne.some(c => selColonne.has(c.id))
    );
    if (gruppiConSel.length === 0) {
      return <div style={{ fontSize: 12, color: "#94A3B8", padding: "8px 0" }}>Nessuna colonna selezionata</div>;
    }
    return (
      <div style={{ maxHeight: 160, overflowY: "auto", padding: "4px 0" }}>
        {gruppiConSel.map(g => {
          const selInG = g.colonne.filter(c => selColonne.has(c.id));
          return (
            <div key={g.nome} style={{ marginBottom: 3 }}>
              <span style={S.colGroupLabel}>{g.nome}:</span>
              {selInG.map(c => (
                <span key={c.id} style={S.colBadge}>
                  {c.label}
                  <span style={S.colBadgeX} onClick={() => toggleColonna(c.id)}>{"\u00d7"}</span>
                </span>
              ))}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div style={S.page}>

      {/* ===== POPUP CONFERMA EXPORT ===== */}
      {popup && (
        <div style={{
          position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)",
          display: "flex", alignItems: "center", justifyContent: "center",
          zIndex: 9999,
        }}>
          <div style={{
            background: "#fff", borderRadius: 14, padding: "32px 28px",
            width: 400, boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            fontFamily: "'DM Sans', sans-serif",
          }}>
            {popup.volumeElevato ? (
              <>
                <div style={{ fontSize: 32, textAlign: "center", marginBottom: 12 }}>⚠️</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: "#92400E", textAlign: "center", marginBottom: 12 }}>
                  Volume elevato
                </div>
                <div style={{
                  background: "#FFFBEB", border: "1px solid #FCD34D",
                  borderRadius: 8, padding: "12px 14px", marginBottom: 20,
                  fontSize: 13, color: "#92400E", lineHeight: 1.6,
                }}>
                  Stai tentando di esportare <strong>{popup.num !== null ? popup.num.toLocaleString("it-IT") : "N/D"} partite</strong>.<br />
                  Per volumi superiori a 5.000 partite l'export non è supportato.<br />
                  Applica uno o più filtri per ridurre il numero di partite.
                </div>
                <button
                  onClick={() => setPopup(null)}
                  style={{
                    width: "100%", padding: "10px 0", fontSize: 13, fontWeight: 700,
                    background: "#F1F5F9", color: "#475569", border: "1px solid #E2E8F0",
                    borderRadius: 8, cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
                  }}
                >
                  Annulla
                </button>
              </>
            ) : (
              <>
                <div style={{ fontSize: 32, textAlign: "center", marginBottom: 12 }}>📥</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: "#1E293B", textAlign: "center", marginBottom: 12 }}>
                  Conferma export
                </div>
                <div style={{
                  background: "#F0FDF4", border: "1px solid #BBF7D0",
                  borderRadius: 8, padding: "12px 14px", marginBottom: 20,
                  fontSize: 13, color: "#166534", lineHeight: 1.6, textAlign: "center",
                }}>
                  Stai per esportare <strong>{popup.num !== null ? popup.num.toLocaleString("it-IT") : "N/D"} partite</strong>.<br />
                  Vuoi procedere con il download?
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <button
                    onClick={() => setPopup(null)}
                    style={{
                      flex: 1, padding: "10px 0", fontSize: 13, fontWeight: 700,
                      background: "#F1F5F9", color: "#475569", border: "1px solid #E2E8F0",
                      borderRadius: 8, cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
                    }}
                  >
                    Annulla
                  </button>
                  <button
                    onClick={confermaExport}
                    style={{
                      flex: 1, padding: "10px 0", fontSize: 13, fontWeight: 700,
                      background: "#08976D", color: "#fff", border: "none",
                      borderRadius: 8, cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
                    }}
                  >
                    Conferma download
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <h1 style={S.title}>{"\uD83D\uDCE5"} Esporta Database</h1>
      <p style={S.subtitle}>
        Esporta su file Excel gli eventi del database.
      </p>

      <div style={S.layout}>
        {/* ===== COLONNA SINISTRA — Filtri + Azioni ===== */}
        <div style={S.colSx}>
          <div style={S.card}>
            <div style={S.cardTitle}>Filtri selezione partite</div>
            {renderMultiSelect("Stagione", stagioni, selStagioni, setSelStagioni)}
            {renderMultiSelect("Campionato / Lega", campionati, selLeghe, setSelLeghe)}
            <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
              <div style={{ flex: 1 }}>
                <label style={S.label}>Data da</label>
                <input type="date" style={S.input} value={dataDa} onChange={e => setDataDa(e.target.value)} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={S.label}>Data a</label>
                <input type="date" style={S.input} value={dataA} onChange={e => setDataA(e.target.value)} />
              </div>
            </div>
            <div style={{ marginBottom: 4 }}>
              <label style={S.label}>Tipo risultato</label>
              <select style={S.select} value={tipoRisultato} onChange={e => setTipoRisultato(e.target.value)}>
                <option value="tutte">Tutte le partite</option>
                <option value="con_risultato">Solo con risultato</option>
                <option value="senza_risultato">Solo senza risultato (foglio quote)</option>
              </select>
            </div>
          </div>

          <div style={S.card}>
            <div style={S.cardTitle}>Azioni</div>
            <button
              style={{ ...S.btn, ...S.btnPrimary, width: "100%", marginBottom: 10, opacity: loading ? 0.6 : 1 }}
              onClick={contaPartite}
              disabled={loading}
            >
              {loading ? "Conteggio..." : "\uD83D\uDD0D Conta partite"}
            </button>
            {conteggio !== null && conteggio >= 0 && (
              <div style={S.conteggio}>
                <span>Partite trovate:</span>
                <span style={S.conteggioNum}>{conteggio.toLocaleString("it-IT")}</span>
              </div>
            )}
            {conteggio === -1 && (
              <div style={{ ...S.conteggio, color: "#DC2626", borderColor: "#FECACA" }}>
                Errore di connessione
              </div>
            )}
            {conteggio !== null && conteggio > 5000 && (
              <div style={{
                padding: "10px 12px", borderRadius: 8, marginBottom: 10,
                background: "#FFFBEB", border: "1px solid #FCD34D",
                fontSize: 12, color: "#92400E", lineHeight: 1.5,
              }}>
                ⚠️ <strong>Volume elevato ({conteggio.toLocaleString("it-IT")} partite).</strong><br />
                Per volumi superiori a 5.000 partite l'export non è supportato. Applica uno o più filtri per ridurre il numero di partite.
              </div>
            )}
            <button
              style={{
                ...S.btn, ...S.btnSuccess, width: "100%",
                opacity: exporting || selColonne.size === 0 ? 0.5 : 1,
              }}
              onClick={esportaExcel}
              disabled={exporting || selColonne.size === 0}
            >
              {exporting ? "Generazione Excel..." : "\uD83D\uDCE5 Esporta Excel"}
            </button>
          </div>
        </div>

        {/* ===== COLONNA DESTRA — Selezione colonne ===== */}
        <div style={S.colDx}>
          <div style={{ ...S.card, marginBottom: 0 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ ...S.cardTitle, marginBottom: 0 }}>Selezione colonne</span>
                <span style={{ fontSize: 11, color: "#94A3B8", fontWeight: 500 }}>
                  ({selColonne.size}/{TUTTE_COLONNE.length})
                </span>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <button style={{ ...S.btn, ...S.btnSecondary, ...S.btnSmall }} onClick={selezionaTutte}>
                  Seleziona tutte
                </button>
                <button style={{ ...S.btn, ...S.btnSecondary, ...S.btnSmall }} onClick={deselezionaTutte}>
                  Deseleziona tutte
                </button>
                <button style={{ ...S.btn, ...S.btnSecondary, ...S.btnSmall }} onClick={ripristinaDefault}>
                  Ripristina default
                </button>
              </div>
            </div>

            <div style={{
              background: "#FAFBFC", borderRadius: 8, border: "1px solid #F1F5F9",
              padding: "8px 12px", marginBottom: 14,
            }}>
              {renderBadgeColonne()}
            </div>

            <div style={{ maxHeight: "calc(100vh - 340px)", overflowY: "auto" }}>
              {GRUPPI_COLONNE.map(gruppo => {
                const isOpen = gruppiAperti[gruppo.nome] ?? false;
                const selInGruppo = gruppo.colonne.filter(c => selColonne.has(c.id)).length;
                const tuttiSel = selInGruppo === gruppo.colonne.length;
                return (
                  <div key={gruppo.nome} style={{ borderBottom: "1px solid #F1F5F9" }}>
                    <div style={S.groupHeader}>
                      <input
                        type="checkbox"
                        checked={tuttiSel}
                        onChange={() => toggleGruppo(gruppo.nome)}
                        style={{ cursor: "pointer", accentColor: "#2563EB" }}
                      />
                      <span
                        style={{ fontSize: 13, cursor: "pointer", color: "#64748B", minWidth: 14 }}
                        onClick={() => setGruppiAperti(prev => ({ ...prev, [gruppo.nome]: !isOpen }))}
                      >
                        {isOpen ? "\u25BC" : "\u25B6"}
                      </span>
                      <span style={S.groupName}
                        onClick={() => setGruppiAperti(prev => ({ ...prev, [gruppo.nome]: !isOpen }))}>
                        {gruppo.nome}
                      </span>
                      <span style={S.groupCount}>
                        {selInGruppo}/{gruppo.colonne.length}
                      </span>
                    </div>
                    {isOpen && (
                      <div style={{ paddingLeft: 32, paddingBottom: 6, display: "flex", flexWrap: "wrap" }}>
                        {gruppo.colonne.map(col => (
                          <label key={col.id} style={S.colItem}>
                            <input
                              type="checkbox"
                              checked={selColonne.has(col.id)}
                              onChange={() => toggleColonna(col.id)}
                              style={{ accentColor: "#2563EB" }}
                            />
                            {col.label}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
